import { render, staticRenderFns } from "./Assessmenttaskuser.vue?vue&type=template&id=36fbaa5a&scoped=true"
import script from "./Assessmenttaskuser.vue?vue&type=script&lang=js"
export * from "./Assessmenttaskuser.vue?vue&type=script&lang=js"
import style0 from "./Assessmenttaskuser.vue?vue&type=style&index=0&id=36fbaa5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbaa5a",
  null
  
)

export default component.exports